module.exports = __webpack_public_path__ + "static/media/model-shogun-sport-96.69888757.webp";